import { StyleSheet } from 'react-native';
import Colors from '../../constants/Colors';

// Shared between SearchEmptyState.jsx (legacy) and map/SiteSearchEmptyState.tsx (Sites/FreshTrak) --
// both empty states share the same layout and typography, differing only in copy/content.
const searchEmptyStateStyles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 32,
    paddingTop: 64,
  },
  title: {
    fontSize: 20,
    fontWeight: '600',
    color: Colors.darkText || '#333',
    marginBottom: 8,
    textAlign: 'center',
  },
  subtitle: {
    fontSize: 16,
    color: Colors.grayText || '#666',
    marginBottom: 24,
    textAlign: 'center',
  },
  suggestion: {
    fontSize: 16,
    fontWeight: '500',
    color: Colors.darkText || '#333',
    marginBottom: 12,
    textAlign: 'center',
  },
  suggestionItem: {
    fontSize: 14,
    color: Colors.grayText || '#666',
    marginBottom: 4,
    textAlign: 'center',
  },
});

export default searchEmptyStateStyles;
